import React from "react";
import { Menu, MenuItem } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFolderMinus,
  faEllipsisH,
  faPencilAlt,
} from "@fortawesome/free-solid-svg-icons";

export default function FileActionsButton(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const renameItem = () => {
    props.renameItem();
    handleClose();
  };
  const deleteFolder = () => {
    props.deleteFolder();
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? "add-file-menu" : undefined;

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        className="file-button-wrapper"
        onClick={handleClick}
      >
        <svg
          viewBox="0 0 62 62"
          className="file-button"
          style={{ enableBackground: "new 0 0 60.364 60.364" }}
        >
          <FontAwesomeIcon icon={faEllipsisH} />
        </svg>
      </div>
      <Menu
        id={id}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={deleteFolder}>
          <FontAwesomeIcon icon={faFolderMinus} />
          &nbsp;&nbsp;
          {props.type === "FOLDER" && "Delete Folder"}
          {props.type !== "FOLDER" && "Remove Item"}
        </MenuItem>
        {props.type !== "FOLDER" && (
          <MenuItem onClick={renameItem}>
            <FontAwesomeIcon icon={faPencilAlt} />
            &nbsp;&nbsp;Rename Item
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
